import { property as propertyApi,virtual  as virtualApi} from '@/assets/js/api.url.js';
import Utils from "@/common/util.js";
const property = {
  state: {
    accountBanalce: {},
    followTotalAmount: 0,
    selectType: 'USDT',
    coinSign: '$',
    switchDisplay: true,
    isAnchor: 0, // 1 => 主播
    activeName: "live", 
  },
  mutations: {
    SET_VIRTAL_ACCOUNTBANALCE(state, value) {
      state.accountBanalce = value
    },
    SET_ACCOUNTBANALCE(state, value) {
      state.accountBanalce = value
    },
    SET_FOLLOWTOTALAMOUNT(state, amount) {
      state.followTotalAmount = amount
    },
    
    SET_SELECT_TYPE(state, type) {
      type = type.indexOf('USD') > -1 ? 'USDT' : type
      state.selectType = type
    },
    SET_COIN_SIGN(state, sign) {
      state.coinSign = sign
    },
    REMOVE_AMOUNT(state) {
      state.accountBanalce = {}
      state.followTotalAmount = 0
    },
    SET_SWITCH_DISPLAY(state, status) {
      state.switchDisplay = status
    },
    REMOVE_SWITCH_DISPLAY(state) {
      state.switchDisplay = true
    },
    REMOVE_ACCOUNTBANALCE(state) {
      state.accountBanalce = {}
    },
    SET_ANCHOR(state, status) {
      state.isAnchor = status
    },
    SET_ACTIVENAME(state, name) {
      state.activeName = name
    },
    REMOVE_ANCHOR(state) {
      state.isAnchor = 0
    },
    REMOVE_ACTIVENAME(state) {
      state.isAnchor = 'live'
    }
  },
  actions: {
    getVirtualAccountCoinList({commit}, {type}) {
      const _this = window.vm
      return new Promise((resolve, reject) => {
        Utils.getOssData().then(ress => {
          _this.post(
            `${ress+virtualApi.getAccountList}`, JSON.stringify({ passbookGenre: type }), {
              headers: { "Content-Type": "application/json" }
            }
          ).then((response) => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        })
      })
    },
    getAccountCoinList({commit}, {type}) {
      const _this = window.vm
      return new Promise((resolve, reject) => {
        _this.post(propertyApi.getAccountList, JSON.stringify({ passbookGenre: type }), {
          headers: { "Content-Type": "application/json" }
        }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getAccountBalance({commit}) {
      const _this = window.vm
      return new Promise((resolve, reject) => {
        _this.get(
          `${propertyApi.getAllAssetBalance}`
        ).then((res) => {
          commit("SET_ACCOUNTBANALCE", res.data);
          resolve(res)
          // Utils.getOssData().then(ress => {
          //   _this.get(
          //     `${ress+virtualApi.getAllAssetBalance}`
          //   ).then((_res) => {
          //     res.data['virtualcontractSumExchange'] = _res.data['contractSumExchange']
          //     commit("SET_VIRTAL_ACCOUNTBANALCE", res.data);
          //     // SET_VIRTAL_ACCOUNTBANALCE   virtualApi
          //     resolve(res)
          //   }).catch(error => {
          //     reject(error)
          //   })
          // })
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    getAccountBanalce(state) {
      return state.accountBanalce
    },
    getFollowTotalAmount(state) {
      return state.followTotalAmount
    },
    getSelectType(state) {
      return state.selectType
    },
    getCoinSign(state) {
      return state.coinSign
    },
    getSwitchDisplay(state) {
      return state.switchDisplay
    },
    getAnchor(state) {
      return state.isAnchor
    },
    getActiveName(state) {
      return state.activeName
    }
  }
}

export default property


// WEBPACK FOOTER //
// ./src/store/property/index.js